import Layout from "@/components/layout/Layout";
import SEOHead from "@/components/SEOHead";
import CorporateFinanceHome from "./CorporateFinanceHome";

export default function Index() {
  return (
    <Layout>
      <SEOHead
        title="SYCMA | Investment Banking & M&A Advisory en Español"
        description="Firma boutique de banca de inversión y M&A para empresas hispanohablantes. Levantamiento de capital y CFO as a Service con estándares internacionales."
        path="/"
      />
      <CorporateFinanceHome />
    </Layout>
  );
}
